import React, { Component } from 'react';
import {
  Link,
} from 'react-router-dom';
import StarRatingComponent from 'react-star-rating-component';
import constants from '../config';


class Reviews extends Component {
  constructor(props) {
    super();
    this.state = {

    };

  }

  componentDidMount() {

  }
  componentWillReceiveProps(nextProps) {

  }

  render() {
    const api = `${constants.DOMAIN}/`;
    return (
      <div className="col-md-12 col-xs-12 ReviewList">
        <div className="col-md-12 col-xs-12 review-heading">
          <div className="col-md-2 col-xs-4">
            <Link to={`/shop/${String(this.props.userName)}`}>
              <img id="userPic" alt="userPic" src={api + this.props.picture} style={{ width: '80%' }} />
            </Link>
          </div>
          <div className="col-md-10 col-xs-8 names">
            <span><strong><p id="name">{this.props.name}</p></strong><div >&nbsp;</div><p id="username">@{this.props.userName}</p></span>
          </div>
        </div>
        <div className="stars">
          <StarRatingComponent
            name="rating"
            editing={false}
            starCount={5}
            starColor="#ffd788"
            emptyStarColor="#939393"
            value={this.props.rating}
          />
        </div>
        <div className="col-md-12 reviewtext">
          <p>{this.props.review}</p>
        </div>
      </div>

    );
  }
}

export default Reviews;
